import React from 'react';
import { List as MUIList, ListProps as MUIListProps } from '@mui/material';

interface ListProps extends MUIListProps {
  disc?: boolean;
  ref?: React.Ref<HTMLUListElement>;
}

export const List = ({
  disc = false,
  sx,
  children,
  ref,
  ...props
}: ListProps) => {
  const childrenWithProps = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, { ...(child.props as any), disc: disc });
    }
    return child;
  });
  return (
    <MUIList ref={ref} sx={sx} {...props}>
      {childrenWithProps}
    </MUIList>
  );
};
